import React from 'react';
import { Video } from '../Video';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../store/applicationState';
import { Links } from '../Interactive/components/Links';
import { TitleBlock } from '../TitleBlock';
import { EIcons } from '../../utils/globatTypes';
import styled from 'styled-components';
import { CardS } from '../../GlobalStyles';
import { GetDefaultLink, ShowInteractive } from '../../store/interactive/actions';
import { LikeMessage } from '../../store/sockets/actions';

interface MainProps {}

export const Main: React.FC<MainProps> = () => {
  const { Sockets, Interactive, Video: RVideo } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  const { room, event, currentMessage } = Sockets;
  const { link } = Interactive;

  const memo = React.useMemo(() => {
    return {
      room,
      event,
    };
  }, [room, event]);

  React.useEffect(() => {
    if (memo.event?.typeEvent === 2 && !memo.room?.hideVideo && memo.room) {
      dispatch(ShowInteractive.request({ data: { event_id: memo.room.event_id, roomId: memo.room.absnum } }));
    }
    if (memo.room?.hideVideo && memo.room) {
      dispatch(GetDefaultLink.request({ data: { event_id: memo.room.event_id, roomId: memo.room.absnum } }));
    }
  }, [dispatch, memo]);

  const likeMessage = React.useCallback(
    (messageId: number) => {
      if (room) {
        dispatch(
          LikeMessage.request({
            data: {
              event_id: room.event_id,
              roomId: room.absnum,
              messageId: messageId,
            },
          })
        );
      }
    },
    [dispatch, room]
  );

  if (!event) {
    return null;
  }

  return (
    <>
      {event.typeEvent === 2 || room?.hideVideo ? (
        RVideo.isFullScreen ? (
          <WrapperS>
            <div>
              <TitleBlock title="Головна" icon={EIcons.home} />
            </div>
            <BodyS>{link && RVideo.isFullScreen ? <Links link={link} /> : null}</BodyS>
          </WrapperS>
        ) : null
      ) : (
        <Video message={currentMessage} link={room?.youtube} likeMessage={likeMessage} />
      )}
    </>
  );
};

const WrapperS = styled(CardS)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const BodyS = styled.div`
  flex: 1;
  overflow: auto;
`;
